//libs
import React from 'react';
import { Redirect } from 'react-router';

const ProtectedRoute = ({ isAuthenticated, children, redirectTo = '/' }) => {
  return isAuthenticated ? children : <Redirect to={redirectTo} />;
};

export default ProtectedRoute;
